import { toast } from 'react-toastify';

const Notifications = (message: string, type: number) => {
  switch (type) {
    case 0: {
      toast.error(message, {
        className: 'Toastify__progress-bar--error',
        style: {
          backgroundColor: 'var(--toastify-color-error)',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          color: 'white',
          fontSize: '1rem',
          lineHeight: '1.5rem',
          marginBottom: '1rem',
        },
        icon: () => '🚨',
        autoClose: 3000,
        closeButton: false,
      });

      break;
    }
    case 1: {
      toast.error(message, {
        className: 'Toastify__progress-bar--success',
        style: {
          backgroundColor: 'var(--toastify-color-warning)',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          color: 'white',
          fontSize: '1rem',
          lineHeight: '1.5rem',
          marginBottom: '1rem',
        },
        icon: () => '⚠',
        autoClose: 3000,
        closeButton: false,
      });

      break;
    }
    default: {
      toast.success(message, {
        className: 'Toastify__progress-bar--success',
        style: {
          backgroundColor: 'var(--toastify-color-success)',
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          color: 'white',
          fontSize: '1rem',
          lineHeight: '1.5rem',
          marginBottom: '1rem',
        },
        icon: () => '🎉',
        autoClose: 3000,
        closeButton: false,
      });
    }
  }
};
export default Notifications;
